module.exports = __webpack_public_path__ + "img/minigoldenmixoverviewright.e87944d6.jpg";